module.exports = __webpack_public_path__ + "static/media/03.a7b1fbb8.png";